/** 每次用户发送固定一个 ID，供 PHP/HMS 对重复 WS 帧做幂等。 */
export function createClientMessageId() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID()
  return `msg-${Date.now()}-${Math.random().toString(36).slice(2, 14)}`
}
